<div id="app-category-card">
    <div class="card pointer">
        <div (click)="openCatalog()">
            <div class="flex">
                <div class="aOrder">{{category.displayOrder}}</div>
                <p-progressBar value="{{category.percentage}}" [showValue]="false" class="categoryProgress"
                    id="bar_{{category._id}}"
                    pTooltip="{{('forms.common.completionPercentage' | translate) + ' : ' + category.percentage}}">
                </p-progressBar>
            </div>
            <div class="content flex">
                <div class="grow ctitle">
                    <h4>{{category.name}}</h4>
                </div>

                <div class="cContainer">
                    <div class="{{isSub ? 'subCategory' : 'category'}}"></div>
                </div>
            </div>
            <br />
            <br />
        </div>
        <div class="footer" (click)="category.questionsAssessment?.length ? openCatalog() : null">
            <div class="select-container">
                <div class="select-input" *ngIf="processConfig.categoryLevelCount > category.levelNumber">
                    <mat-form-field appearance="standard">
                        <mat-select [placeholder]="'forms.common.go to' | translate" #selectControl
                            (openedChange)="openChanged($event)" (selectionChange)="openSubCategory($event.value)"
                            [formControl]="selected">
                            <ng-container *ngIf="options !== null && isOpen && !isLoading;else loading">
                                <mat-option disabled *ngIf="!options.length">
                                    {{'forms.common.There are no items' | translate}}
                                </mat-option>
                                <mat-option *ngFor="let option of options" [value]="option.key">
                                    {{option.name}}
                                </mat-option>
                            </ng-container>
                            <ng-template #loading>
                                <mat-option disabled>
                                    <div class="deferred-select-placeholder-container">
                                        <span>Loading...</span>
                                    </div>
                                </mat-option>
                            </ng-template>
                        </mat-select>
                    </mat-form-field>

                </div>
            </div>
            <app-assessment-status [status]="category.percentage == 100 && category.hasOptionalInputs ? 1 : 0">
            </app-assessment-status>
        </div>
    </div>
</div>